import {
  ASSET_TYPES,
  BUTTON_LABELS,
  LABELS,
  PLATFORMS_LABELS,
  SECURITY_RANKINGS_LABELS,
  TABS,
  TITLES,
} from '../components/LandingPageSidePanel/constants';
import { SESSION_DETAILS_MODAL_ISLAND } from '../components/SessionLauncher/constants';

// Helper function to create message objects
const msg = (id, defaultMessage) => ({ id, defaultMessage });

// eslint-disable-next-line import/prefer-default-export
export const msgs = {
  pam: {
    common: {
      successExclamation: msg('pam.common.successExclamation', 'Success!'),
      copy: msg('pam.common.copy', 'Copy'),
      copied: msg('pam.common.copied', 'Copied'),
      save: msg('pam.common.save', 'Save'),
      cancel: msg('pam.common.cancel', 'Cancel'),
      selectAll: msg('pam.common.selectAll', 'Select All'),
      deselectAll: msg('pam.common.deselectAll', 'Deselect All'),
      buttons: {
        edit: msg('pam.common.buttons.edit', 'Edit'),
      },
      links: {
        view: msg('pam.common.links.view', 'View'),
      },
      db: {
        select: msg('pam.common.db.select', 'select'),
        selectLabel: msg(
          'pam.common.db.selectLabel',
          'Fetch records from tables based on the query formulated.'
        ),
        create: msg('pam.common.db.create', 'create'),
        createLabel: msg(
          'pam.common.db.createLabel',
          'Create multiple database objects like functions, indexes, procedures, roles, schemas, synonyms, tables, triggers and views.'
        ),
        alter: msg('pam.common.db.alter', 'alter'),
        alterLabel: msg(
          'pam.common.db.alterLabel',
          'Change the structure of a table.'
        ),
        insert: msg('pam.common.db.insert', 'insert'),
        insertLabel: msg(
          'pam.common.db.insertLabel',
          'Create new row(s) in a table.'
        ),
        update: msg('pam.common.db.update', 'update'),
        updateLabel: msg(
          'pam.common.db.updateLabel',
          'Update existing records in a table.'
        ),
      },
    },
    landingPage: {
      clearSelection: msg('pam.landingPage.clearSelection', 'Clear Selection'),
      clear: msg('pam.landingPage.clear', 'Clear'),
      selected: msg('pam.landingPage.selected', 'Selected'),
      view: msg('pam.landingPage.view', 'View'),
      filter: msg('pam.landingPage.filter', 'Filter'),
      hideSessions: msg('pam.landingPage.hideSessions', 'Hide Sessions'),
      userAccessSearchInputPlaceholder: msg(
        'pam.landingPage.userAccessSearchInputPlaceholder',
        'Search by target system name, application name or role name'
      ),
      userAccessSearchInputPlaceholderJfa: msg(
        'pam.landingPage.userAccessSearchInputPlaceholderJfa',
        'Search by role, application, etc.'
      ),
      description: msg(
        'pam.landingPage.description',
        'Connect to your privileged assets so you can launch live sessions and check credentials out when you need them.'
      ),
      descriptionJfa: msg(
        'pam.landingPage.descriptionJfa',
        'Connect to roles and accounts of applications when you need them through JIT access.'
      ),
      noMatchingSearchRecords: msg(
        'pam.landingPage.noMatchingSearchRecords',
        "Your search doesn't match any records"
      ),
      noAssetsAvailable: msg(
        'pam.landingPage.noAssetsAvailable',
        'There are no available assets'
      ),
      sessionsHeader: msg('pam.landingPage.sessionsHeader', 'Sessions'),
      availableAssetsHeader: msg(
        'pam.landingPage.availableAssetsHeader',
        'Available Assets'
      ),
      availableRolesHeader: msg(
        'pam.landingPage.availableRolesHeader',
        'Available Roles'
      ),
      maxRolesSelected: msg(
        'pam.landingPage.maxRolesSelected',
        'The max number of roles has been reached. Uncheck one to add another.'
      ),
      checkOutRoles: msg('pam.landingPage.checkOutRoles', 'Check Out Roles'),
      bulkRoleSelectPopoverTitle: msg(
        'pam.landingPage.bulkRoleSelectPopoverTitle',
        'Bulk Selection Filtering Applied'
      ),
      bulkRoleSelectPopoverSubTitle: msg(
        'pam.landingPage.bulkRoleSelectPopoverSubTitle',
        'Only roles can be bulk selected currently. Filters and search are available, but some options will be disabled.'
      ),
      bulkRoleSelectPopoverCheckBox: msg(
        'pam.landingPage.bulkRoleSelectPopoverCheckBox',
        'Don’t show me this again'
      ),
      bulkRoleSelectPopoverSubmitButton: msg(
        'pam.landingPage.bulkRoleSelectPopoverSubmitButton',
        'Got It'
      ),
      bulkRoleSelectRoleFilterTooltip: msg(
        'pam.landingPage.bulkRoleSelectRoleFilterTooltip',
        'Filtering by role type is unavailable while taking a bulk action on roles.'
      ),
      account: msg('pam.landingPage.account', 'Account'),
      platform: msg('pam.landingPage.platform', 'Platform'),
      assetType: msg('pam.landingPage.assetType', 'Asset Type'),
      roleType: msg('pam.landingPage.roleType', 'Role Type'),
      errors: {
        assetsNotLoaded: msg(
          'pam.landingPage.errors.assetsNotLoaded',
          'Assets Not Loaded'
        ),
        assetsNotLoadedDesc: msg(
          'pam.landingPage.errors.assetsNotLoadedDesc',
          "Your list of privileged assets didn't load properly. Try again or contact your administrator."
        ),
      },
    },
    requestSubmitAlertBanner: {
      pending: msg(
        'pam.requestSubmitAlertBanner.pending',
        'Your request for {accountName} is Pending Approval.'
      ),
      approved: msg(
        'pam.requestSubmitAlertBanner.approved',
        'Your request for {accountName} has been approved and will be available soon. Refresh your list in a few minutes.'
      ),
    },
    requestRoleSubmitAlertBanner: {
      submitted: msg(
        'pam.requestRoleSubmitAlertBanner.submitted',
        'Your request for {roleName} has been submitted.'
      ),
    },
    upload: {
      uploadFailed: msg('pam.upload.uploadFailed', 'Upload Failed'),
      uploadFailedDesc: msg(
        'pam.upload.uploadFailedDesc',
        'Your files for {accountName} could not be uploaded.'
      ),
    },
    checkIn: {
      modalTitle: msg('pam.checkIn.title', 'Check In'),
      modalDescription: msg(
        'pam.checkIn.description',
        'Are you done with the credential and ready to check in?'
      ),
      successBanner: msg(
        'pam.checkIn.success',
        "You've checked in the credential and your session has ended."
      ),
      modalDescriptionRole: msg(
        'pam.checkIn.descriptionRole',
        'Are you done with the role and ready to check in?'
      ),
      successBannerRole: msg(
        'pam.checkIn.successRole',
        "You've checked in your session for {roleName}."
      ),
      alreadyBanner: msg(
        'SESSION.ALREADY.ENDED',
        'This session has already ended.'
      ),
      error: msg('pam.checkIn.error', 'Error in check-in API:'),
    },
    end: {
      modalTitle: msg('pam.end.title', 'End Session'),
      modalDescription: msg(
        'pam.end.description',
        'Are you done with the session and ready to end it?'
      ),
      successBanner: msg(
        'pam.end.success',
        `You've ended your session for {accountName}.`
      ),
      failureBanner: msg('pam.end.failure', 'End Session Failed'),
      successBannerRole: msg(
        'pam.end.successRole',
        `You've ended your session for {roleName}.`
      ),
    },
    cancelSession: {
      modalTitle: msg('pam.cancelSession.title', 'Cancel Session'),
      modalDescription: msg(
        'pam.cancelSession.description',
        'Do you want to cancel this session?'
      ),
      successBanner: msg(
        'pam.cancelSession.success',
        `You successfully canceled your session for {accountName}.`
      ),
      failureBanner: msg(
        'pam.cancelSession.failure',
        `There was a problem canceling your session for {accountName}. You can try again or contact your administrator.`
      ),
      successBannerRole: msg(
        'pam.cancelSession.successRole',
        `You successfully canceled your session for {roleName}.`
      ),
      failureBannerRole: msg(
        'pam.cancelSession.failureRole',
        `There was a problem canceling your session for {roleName}. You can try again or contact your administrator.`
      ),
    },
    cancelRequest: {
      modalTitle: msg('pam.cancelRequest.title', 'Cancel Request'),
      modalDescription: msg(
        'pam.cancelRequest.description',
        'Do you want to cancel this request?'
      ),
      successBanner: msg(
        'pam.cancelRequest.success',
        `You successfully canceled your request for {accountName}.`
      ),
      failureBanner: msg(
        'pam.cancelRequest.failure',
        `There was a problem canceling your request for {accountName}. You can try again or contact your administrator.`
      ),
      successBannerRole: msg(
        'pam.cancelRequest.successRole',
        `You successfully canceled your request for {roleName}.`
      ),
      failureBannerRole: msg(
        'pam.cancelRequest.failureRole',
        `There was a problem canceling your request for {roleName}. You can try again or contact your administrator.`
      ),
    },
    alertBanner: {
      failureTitle: msg('pam.checkin.failedTitle', `Failed!`),
      successTitle: msg('pam.checkin.successTitle', `Success!`),
      sessionCanceledTitle: msg(
        'pam.checkin.sessionCanceledTitle',
        `Session Canceled.`
      ),
      sessionNotCanceledTitle: msg(
        'pam.checkin.sessionNotCanceledTitle',
        `Session Not Canceled.`
      ),
      requestCanceledTitle: msg(
        'pam.checkin.requestCanceledTitle',
        `Request Canceled.`
      ),
      requestNotCanceledTitle: msg(
        'pam.checkin.requestNotCanceledTitle',
        `Request Not Canceled.`
      ),
    },
    extend: {
      extendFailedDefaultMessage: msg(
        'pam.extend.failed.default',
        'Session Extend failed. Please contact administrator.'
      ),
      extendBeforeStartErrorMessage: msg(
        'pam.extend.failed.extendBeforeStartError',
        'Session Extend failed. The session cannot be extended until after it has started.'
      ),
      alertBannerFailureTitle: msg('pam.checkin.failedTitle', `Failed!`),
      alertBannerSuccessTitle: msg('pam.checkin.successTitle', `Success!`),
      extendSuccessMessage: msg(
        'pam.extend.success',
        "You've extended your access to {accountName} until {endDate1} on {endDate2}."
      ),
      extendDurationAllowed: msg(
        'pam.extend.durationAllowed',
        "Adjust your end time. Your session can't exceed a total of {maxDuration} hours."
      ),
      extendDurationConflicts: msg(
        'pam.extend.durationConflicts',
        'Adjust your end time. Another session with this asset is scheduled to start at {startDateOfNextBlockedSession1} on {startDateOfNextBlockedSession2}'
      ),
      modalTitle: msg('pam.extend.modalTitle', 'Extend Session'),
      startTime: msg('pam.extend.startTime', 'Start Time'),
      endDate: msg('pam.extend.endDate', 'End Date'),
      endTime: msg('pam.extend.endTime', 'End Time'),
      justification: msg('pam.extend.justification', 'Justification'),
      cancel: msg('pam.common.cancel', 'Cancel'),
      justifPlaceholder: msg(
        'pam.modalPage.justificationDetails.justifPlaceholder',
        'Provide a reason for your request'
      ),
      extendLabel: msg('pam.sidePanel.extend', 'Extend'),
    },
    sidePanel: {
      checkoutCredential: msg(
        'pam.coc.page.modalHeader',
        BUTTON_LABELS.CHECKOUT_CREDENTIAL
      ),
      checkoutCredentials: msg(
        'pam.sidePanel.checkoutCredentials',
        BUTTON_LABELS.CHECKOUT_CREDENTIALS
      ),
      checkoutCredentialButtonTooltip: msg(
        'pam.sidePanel.checkoutCredentialButtonTooltip',
        'Credential checkout unavailable. Try refreshing or contact your administrator.'
      ),
      connectToSession: msg(
        'pam.sidePanel.connectToSession',
        BUTTON_LABELS.CONNECT_TO_SESSION
      ),
      checkIn: msg('pam.sidePanel.checkIn', BUTTON_LABELS.CHECK_IN),
      end: msg('pam.sidePanel.end', BUTTON_LABELS.END),
      extend: msg('pam.sidePanel.extend', BUTTON_LABELS.EXTEND),
      cancelRequest: msg(
        'pam.sidePanel.cancelRequest',
        BUTTON_LABELS.CANCEL_REQUEST
      ),
      cancelSession: msg(
        'pam.sidePanel.cancelSession',
        BUTTON_LABELS.CANCEL_SESSION
      ),
      launchSession: msg(
        'pam.sidePanel.launchSession',
        BUTTON_LABELS.LAUNCH_SESSION
      ),
      extendSession: msg(
        'pam.sidePanel.extendSession',
        BUTTON_LABELS.EXTEND_SESSION
      ),
      endSession: msg('pam.sidePanel.endSession', BUTTON_LABELS.END_SESSION),
      checkoutRole: msg(
        'pam.sidePanel.checkoutRole',
        BUTTON_LABELS.CHECKOUT_ROLE
      ),
      showAll: msg('pam.sidePanel.showAll', BUTTON_LABELS.SHOW_ALL),
      viewDetails: msg('pam.sidePanel.viewDetails', BUTTON_LABELS.VIEW_DETAILS),
      cancel: msg('pam.sidePanel.cancel', BUTTON_LABELS.CANCEL),
      server: msg('pam.sidePanel.server', ASSET_TYPES.SERVER),
      application: msg('pam.sidePanel.application', ASSET_TYPES.APPLICATION),
      database: msg('pam.sidePanel.database', ASSET_TYPES.DATABASE),
      session: msg('pam.sidePanel.session', TABS.SESSION),
      asset: msg('pam.sidePanel.asset', TABS.ASSET),
      account: msg('pam.sidePanel.account', TABS.ACCOUNT),
      role: msg('pam.sidePanel.role', TABS.ROLE),
      entitlements: msg('pam.sidePanel.entitlements', TABS.ENTITLEMENTS),
      schedule: msg('pam.sidePanel.schedule', TABS.SCHEDULE),
      summary: msg('pam.sidePanel.summary', TITLES.SUMMARY),
      systemDetails: msg('pam.sidePanel.systemDetails', TITLES.SYSTEM_DETAILS),
      time: msg('pam.sidePanel.time', TITLES.TIME),
      requestDetails: msg(
        'pam.sidePanel.requestDetails',
        TITLES.REQUEST_DETAILS
      ),
      comments: msg('pam.sidePanel.comments', TITLES.COMMENTS),
      attachments: msg('pam.sidePanel.attachments', TITLES.ATTACHMENTS),
      targetSystem: msg('pam.sidePanel.targetSystem', TITLES.TARGET_SYSTEM),
      remoteApplication: msg(
        'pam.sidePanel.remoteApplication',
        TITLES.REMOTE_APPLICATION
      ),
      sapTransactionCodes: msg(
        'pam.sidePanel.sapTransactionCodes',
        TITLES.SAP_TRANSACTION_CODES
      ),
      customProperties: msg(
        'pam.sidePanel.customProperties',
        TITLES.CUSTOM_PROPERTIES
      ),
      securityRankings: msg(
        'pam.sidePanel.securityRankings',
        TITLES.SECURITY_RANKINGS
      ),
      accountType: msg('pam.sidePanel.accountType', LABELS.ACCOUNT_TYPE),
      startTime: msg('pam.sidePanel.startTime', LABELS.START_TIME),
      endTime: msg('pam.sidePanel.endTime', LABELS.END_TIME),
      name: msg('pam.sidePanel.name', LABELS.NAME),
      platform: msg('pam.sidePanel.platform', LABELS.PLATFORM),
      location: msg('pam.sidePanel.location', LABELS.LOCATION),
      id: msg('pam.sidePanel.id', LABELS.ID),
      awsAccount: msg('pam.sidePanel.awsAccount', PLATFORMS_LABELS.AWS_ACCOUNT),
      gcpAccount: msg('pam.sidePanel.gcpAccount', PLATFORMS_LABELS.GCP_PROJECT),
      databaseName: msg('pam.sidePanel.databaseName', LABELS.DATABASE_NAME),
      rdsType: msg('pam.sidePanel.rdsType', LABELS.RDS_TYPE),
      operatingSystem: msg(
        'pam.sidePanel.operatingSystem',
        LABELS.OPERATING_SYSTEM
      ),
      environment: msg('pam.sidePanel.environment', LABELS.ENVIRONMENT),
      network: msg('pam.sidePanel.network', LABELS.NETWORK),
      publicIP: msg('pam.sidePanel.publicIP', LABELS.PUBLIC_IP),
      privateIP: msg('pam.sidePanel.privateIP', LABELS.PRIVATE_IP),
      description: msg('pam.sidePanel.description', LABELS.DESCRIPTION),
      authenticationMechanism: msg(
        'pam.sidePanel.authenticationMechanism',
        LABELS.AUTHENTICATION_MECHANISM
      ),
      requestStatus: msg('pam.sidePanel.requestStatus', LABELS.REQUEST_STATUS),
      requestId: msg('pam.sidePanel.requestId', LABELS.REQUEST_ID),
      requestTime: msg('pam.sidePanel.requestTime', LABELS.REQUEST_TIME),
      assignedTo: msg('pam.sidePanel.assignedTo', LABELS.ASSIGNED_TO),
      ticketNumber: msg('pam.sidePanel.ticketNumber', LABELS.TICKET_NUMBER),
      justification: msg('pam.sidePanel.justification', LABELS.JUSTIFICATION),
      tCodesSelected: msg(
        'pam.sidePanel.tCodesSelected',
        LABELS.T_CODES_SELECTED
      ),
      approvedBy: msg('pam.sidePanel.approvedBy', LABELS.APPROVED_BY),
      approvalTime: msg('pam.sidePanel.approvalTime', LABELS.APPROVAL_TIME),
      targetServer: msg('pam.sidePanel.targetServer', LABELS.TARGET_SERVER),
      portNumber: msg('pam.sidePanel.portNumber', LABELS.PORT_NUMBER),
      databaseType: msg('pam.sidePanel.databaseType', LABELS.DATABASE_TYPE),
      ipHost: msg('pam.sidePanel.ipHost', LABELS.IP_HOST),
      instanceOS: msg('pam.sidePanel.instanceOS', LABELS.INSTANCE_OS),
      pendingApproval: msg(
        'pam.sidePanel.pendingApproval',
        LABELS.PENDING_APPROVAL
      ),
      assetDidntLoadError: msg(
        'pam.sidePanel.assetDidntLoadError',
        "This asset didn't load properly. Try again or contact your administrator."
      ),
      risk: msg('pam.sidePanel.risk', LABELS.RISK),
      soxCritical: msg('pam.sidePanel.soxCritical', LABELS.SOX_CRITICAL),
      sysCritical: msg('pam.sidePanel.sysCritical', LABELS.SYS_CRITICAL),
      privileged: msg('pam.sidePanel.privileged', LABELS.PRIVILEGED),
      confidentiality: msg(
        'pam.sidePanel.confidentiality',
        LABELS.CONFIDENTIALITY
      ),
      securityRankingValues: {
        veryLow: msg(
          'pam.sidePanel.veryLow',
          SECURITY_RANKINGS_LABELS.VERY_LOW
        ),
        low: msg('pam.sidePanel.low', SECURITY_RANKINGS_LABELS.LOW),
        medium: msg('pam.sidePanel.medium', SECURITY_RANKINGS_LABELS.MEDIUM),
        high: msg('pam.sidePanel.high', SECURITY_RANKINGS_LABELS.HIGH),
        critical: msg(
          'pam.sidePanel.critical',
          SECURITY_RANKINGS_LABELS.CRITICAL
        ),
      },
      searchEntitlementsPlaceholder: msg(
        'pam.sidePanel.searchEntitlementsPlaceholder',
        'Search by entitlement name or description'
      ),
      searchEntitlementsModalPlaceholder: msg(
        'pam.sidePanel.searchEntitlementsModalPlaceholder',
        'Search by entitlement name, type, value, description, or app name'
      ),
      noAccountsEntitlementsMessage: msg(
        'pam.landingPage.noAccountsEntitlementsMessage',
        "An account with the associated entitlements will be created once you're approved to check out this role. Only entitlements without an account will have one created."
      ),
      customPropertiesModalSubheading: msg(
        'pam.sidePanel.customPropertiesModalSubheading',
        'Review the unique properties included with this role that are specific to your organization and its policies.'
      ),
      entitlementsModalSubheading: msg(
        'pam.sidePanel.entitlementsModalSubheading',
        'View the entitlements you need within this role.'
      ),
      futureApprovedSessionInlineMsg: msg(
        'pam.sidePanel.futureApprovedSessionInlineMsg',
        'Loading your session. If the session is taking longer than expected to load, refresh the screen or try again after some time.'
      ),
      startsIn: msg('pam.sidePanel.startsIn', 'Starts in'),
      left: msg('pam.sidePanel.left', 'left'),
      mfaUnsuccessful: msg(
        'pam.sidePanel.mfaUnsuccessful',
        "Your MFA verification was unsuccessful or wasn't entered correctly."
      ),
      tryAgain: msg('pam.sidePanel.tryAgain', 'Try Again'),
      generate: msg('pam.sidePanel.generate', 'Generate'),
      generateFailure: msg(
        'pam.sidePanel.generateFailure',
        'Failed to generate SSH command token. Please try again or contact your admin if the issue persists.'
      ),
      sshCommand: msg('pam.sidePanel.sshCommand', 'SSH Command'),
      more: msg('pam.sidePanel.more', 'more'),
      entitlementType: msg('pam.sidePanel.entitlementType', 'Entitlement Type'),
      securitySystem: msg('pam.sidePanel.securitySystem', 'Security System'),
    },
    pamManageItemsModal: {
      modalHeader: msg(
        'pam.pamManageItemsModal.modalHeader',
        'Manage Selections'
      ),
      modalSubTitle: msg(
        'pam.pamManageItemsModal.modalSubTitle',
        'View or remove the roles associated with this privileged access request'
      ),
      modalSubTitleInlineMsg: msg(
        'pam.pamManageItemsModal.modalSubTitleInlineMsg',
        'Review or remove your role selections here. Go back to the selection page to add more roles.'
      ),
      modalSelectionPage: msg(
        'pam.pamManageItemsModal.modalSelectionPage',
        'Selection Page'
      ),
      modalFooterMsg: msg(
        'pam.pamManageItemsModal.modalFooterMsg',
        'Check at least one item to proceed.'
      ),
      modalSave: msg('pam.common.save', 'Save'),
      modalCancel: msg('pam.common.cancel', 'Cancel'),
    },
    cts: {
      db: {
        jitAccount: msg('pam.cts.db.jitAccount', 'JIT Account'),
        jitAccountDetails: msg(
          'pam.cts.db.jitAccountDetails',
          'Account Details'
        ),
        jitAccountName: msg('pam.cts.db.jitAccountName', 'Account Name'),
        jitAccountDesc: msg('pam.cts.db.jitAccountDesc', 'Account Description'),
        jitAccountValue: msg(
          'pam.cts.db.jitAccountValue',
          'This is a one-time-use account for Just-in-Time (JIT) access.'
        ),
        jitEntitlementsNeeded: msg(
          'pam.cts.db.jitEntitlementsNeeded',
          'Which entitlements do you need for your JIT account?'
        ),
        jitEntitlements: msg('pam.cts.db.jitEntitlements', 'Entitlements'),
        jitTempPrivilegedAccount: msg(
          'pam.cts.db.jitTempPrivilegedAccount',
          'Temporary Privileged Account (JIT)'
        ),
        jitTempPrivAcctModalTitle: msg(
          'pam.cts.db.jitTempPrivAcctModalTitle',
          'Temporary Privileged Account'
        ),
        jitTempAcctModalSubTitle: msg(
          'pam.cts.db.jitCreateTempAcctModalSubtitle',
          'Create a new one-time-use account for Just-in-Time (JIT) access.'
        ),
      },
      page: {
        modalHeader: msg('pam.cts.page.modalHeader', 'Connect To Session'),
      },
    },
    coc: {
      page: {
        modalHeader: msg('pam.coc.page.modalHeader', 'Check Out Credential'),
      },
    },
    cor: {
      page: {
        modalHeader: msg('pam.cor.page.modalHeader', 'Check Out Role'),
        manageItems: msg('pam.cor.page.manageItems', 'Manage Items'),
      },
    },
    modalPage: {
      credentialRequest: {
        comment: msg(
          'pam.modalPage.credentialRequest.comment',
          'This user is requesting privileged access. No additional comments are needed.'
        ),
      },
      page: {
        noAccountsToDisplay: msg(
          'pam.modalPage.page.noAccountsToDisplay',
          'There are no accounts to be displayed.'
        ),
        submitBtn: msg('pam.modalPage.page.submitBtn', 'Submit'),
        viewScheduleLink: msg(
          'pam.modalPage.page.viewScheduleLink',
          'View Schedule'
        ),
      },
      critical: {
        submitErrorAlert: msg(
          'pam.modalPage.critical.submitErrorAlert',
          'Submit Failure'
        ),
        customRangeCritical: msg(
          'pam.modalPage.critical.customRangeCritical',
          'Duration must be a minimum of 5 minutes and a maximum of {date}.'
        ),
        sessionConflictWarning: msg(
          'pam.modalPage.critical.sessionConflictWarning',
          'The duration you entered conflicts with another session starting at {date}.'
        ),
        sessionExpiredWarning: msg(
          'pam.modalPage.critical.sessionExpiredWarning',
          'Your original start time has passed. We adjusted your request for the next available time and duration. You can make adjustments if needed, then save and submit your request.'
        ),
        editingAlert: msg(
          'pam.modalPage.critical.editingAlert',
          "You've made changes to this request that haven't been saved."
        ),
        editButtonsMessage: msg(
          'pam.modalPage.critical.editButtonsMessage',
          'You must save or discard your changes.'
        ),
        timeConflictTextForBulkRoleSelect: msg(
          'pam.modalPage.critical.timeConflictTextForBulkRoleSelect',
          'Some of the selected roles are currently checked out. Some time slot options are not available.'
        ),
      },
      accordionHeading: {
        accountHeader: msg(
          'pam.modalPage.accordionHeading.accountHeader',
          'Which account do you need?'
        ),
        accountSubheader: msg(
          'pam.modalPage.accordionHeading.accountSubheader',
          'Select an account or create a new one'
        ),
        noAccountRecords: msg(
          'pam.modalPage.accordionHeading.noAccountRecords',
          'No records found. This asset requires a JIT account for privileged sessions.'
        ),
        searchPlaceholder: msg(
          'pam.modalPage.accordionHeading.searchPlaceholder',
          'Search by application name or description'
        ),
        noAccountMatchingRecords: msg(
          'pam.modalPage.accordionHeading.noAccountMatchingRecords',
          "Your search doesn't match any records"
        ),
        appLauncherHeader: msg(
          'pam.modalPage.accordionHeading.appLauncherHeader',
          'What would you like to connect to?'
        ),
        appLauncherSubheader: msg(
          'pam.modalPage.accordionHeading.appLauncherSubheader',
          'Select Application Launcher'
        ),
        serverDetailsHeader: msg(
          'pam.modalPage.accordionHeading.serverDetailsHeader',
          'What server would you like to connect to?'
        ),
        serverDetailsSubheader: msg(
          'pam.modalPage.accordionHeading.serverDetailsSubheader',
          'Enter the Target Server Details'
        ),
        durationHeader: msg(
          'pam.modalPage.accordionHeading.durationHeader',
          'When do you need access?'
        ),
        durationSubheader: msg(
          'pam.modalPage.accordionHeading.durationSubheader',
          'Select a timeframe'
        ),
        tCodeHeader: msg(
          'pam.modalPage.accordionHeading.tCodeHeader',
          'What transaction codes (T-Codes) do you need?'
        ),
        tCodeSubheader: msg(
          'pam.modalPage.accordionHeading.tCodeSubheader',
          'Select the SAP transaction codes you need.'
        ),
        detailsHeader: msg(
          'pam.modalPage.accordionHeading.detailsHeader',
          'Do you have other details to include?'
        ),
        detailsSubheader: msg(
          'pam.modalPage.accordionHeading.detailsSubheader',
          'Provide optional comments, attachments, and ticket number'
        ),
      },
      accountSelection: {
        moreLink: msg('pam.modalPage.accountSelection.moreLink', 'Show More'),
        dataBaseLabelHeading: msg(
          'pam.modalPage.accountSelection.dataBaseLabelHeading',
          'Create a Temporary Privileged Account'
        ),
        dataBaseLabelSubheading: msg(
          'pam.modalPage.accountSelection.dataBaseLabelSubheading',
          'Create a new one-time-use account for Just-in-Time (JIT) access.'
        ),
        dataBaseButton: msg(
          'pam.modalPage.accountSelection.dataBaseButton',
          'Create Account'
        ),
        jitRadioLabel: msg(
          'pam.modalPage.accountSelection.jitRadioLabel',
          'Create a New Account'
        ),
        accountRadioGroupLabel: msg(
          'pam.modalPage.accountSelection.accountRadioGroupLabel',
          'Select a Current Account'
        ),
        accountDescriptionTruncateLabel: msg(
          'pam.modalPage.accountSelection.accountDescriptionTruncateLabel',
          'Truncated Account Description'
        ),
        changeAccount: msg(
          'pam.modalPage.accountSelection.changeAccount',
          'Change Accounts'
        ),
        inLineMessage: msg(
          'pam.modalPage.accountSelection.inLineMessage',
          'Account selection unavailable. An issue occurred and only temporary privileged accounts are available. Try refreshing or contact your administrator.'
        ),
        alertTitle: msg(
          'pam.modalPage.accountSelection.alertTitle',
          'Change Accounts?'
        ),
        alertSubTitle: msg(
          'pam.modalPage.accountSelection.alertSubTitle',
          "If you change accounts, your JIT account and all entitlements you've selected will be discarded."
        ),
        searchPlaceholder: msg(
          'pam.modalPage.accountSelection.searchPlaceholder',
          'Search by account name or description'
        ),
      },
      timeAccessDuration: {
        toggleTabNow: msg(
          'pam.modalPage.timeAccessDuration.toggleTabNow',
          'Now'
        ),
        toggleTabFuture: msg(
          'pam.modalPage.timeAccessDuration.toggleTabFuture',
          'Future'
        ),
        duration: msg('pam.modalPage.timeAccessDuration.duration', 'Duration'),
        discardChanges: msg(
          'pam.modalPage.timeAccessDuration.discardChanges',
          'Discard Changes'
        ),
      },
      customDuration: {
        invalidInterval: msg(
          'pam.modalPage.customDuration.invalidInterval',
          'Invalid interval'
        ),
        inputLabel: msg(
          'pam.modalPage.customDuration.inputLabel',
          'Custom duration'
        ),
        inputPlacholder: msg(
          'pam.modalPage.customDuration.inputPlacholder',
          'Enter number'
        ),
      },
      durationChips: {
        custom: msg('pam.modalPage.durationChips.custom', 'Custom'),
        tooltip: msg(
          'pam.modalPage.durationChips.tooltip',
          'Unavailable due to another booking'
        ),
      },
      durationContinueButton: {
        buttonText: msg(
          'pam.modalPage.durationContinueButton.buttonText',
          'Continue'
        ),
      },
      intervals: {
        minutes: msg('pam.modalPage.intervals.minutes', 'Minutes'),
        hours: msg('pam.modalPage.intervals.hours', 'Hours'),
        days: msg('pam.modalPage.intervals.days', 'Days'),
      },
      chipOptions: {
        thirtyMin: msg('pam.modalPage.chipOptions.thirtyMin', '30 min'),
        oneHour: msg('pam.modalPage.chipOptions.oneHour', '1 hour'),
        twoHours: msg('pam.modalPage.chipOptions.twoHours', '2 hours'),
        fourHours: msg('pam.modalPage.chipOptions.fourHours', '4 hours'),
        eightHours: msg('pam.modalPage.chipOptions.eightHours', '8 hours'),
      },
      dateAndTimePicker: {
        startDate: msg(
          'pam.modalPage.dateAndTimePicker.startDate',
          'Start Date'
        ),
        endDate: msg('pam.modalPage.dateAndTimePicker.endDate', 'End Date'),
        startTime: msg(
          'pam.modalPage.dateAndTimePicker.startTime',
          'Start Time'
        ),
        endTime: msg('pam.modalPage.dateAndTimePicker.endTime', 'End Time'),
      },
      tCodes: {
        tCodesPlaceholder: msg(
          'pam.modalPage.tCodes.tCodesPlaceholder',
          'Start typing to select T-Codes for your request'
        ),
        noTcodes: msg('pam.modalPage.tCodes.noTcodes', 'No T-Codes found'),
        loadingResults: msg(
          'pam.modalPage.tCodes.loadingResults',
          'Loading results...'
        ),
        maxAllowedTcodes: msg(
          'pam.modalPage.tCodes.maxAllowedTcodes',
          'A max of 20 T-Codes can be selected. To add others, remove some first.'
        ),
      },
      justificationDetails: {
        justifLabel: msg(
          'pam.modalPage.justificationDetails.justifLabel',
          'Justification'
        ),
        justifPlaceholder: msg(
          'pam.modalPage.justificationDetails.justifPlaceholder',
          'Provide a reason for your request'
        ),
        justifADPlaceholder: msg(
          'pam.modalPage.justificationDetails.justifADPlaceholder',
          'List the servers you need to access and provide a reason'
        ),
        ticketLabel: msg(
          'pam.modalPage.justificationDetails.ticketLabel',
          'Ticket Number (optional)'
        ),
        ticketPlaceholder: msg(
          'pam.modalPage.justificationDetails.ticketPlaceholder',
          'Enter ticket number'
        ),
        attachTitle: msg(
          'pam.modalPage.justificationDetails.attachTitle',
          'Attachments'
        ),
      },
      scheduleModal: {
        schedule: msg('pam.coc.scheduleModal.schedule', 'Schedule'),
        assetLabel: msg('pam.coc.scheduleModal.assetLabel', 'Asset'),
        accountLabel: msg('pam.coc.scheduleModal.accountLabel', 'Account'),
        roleLabel: msg('pam.coc.scheduleModal.roleLabel', 'Role'),
        timeZoneLabel: msg('pam.coc.scheduleModal.timeZoneLabel', 'Time Zone'),
        available: msg('pam.coc.scheduleModal.available', 'Available'),
        unavailable: msg('pam.coc.scheduleModal.unavailable', 'Unavailable'),
        status: msg('pam.coc.scheduleModal.status', 'Status'),
        roles: msg('pam.coc.scheduleModal.roles', 'Roles'),
      },
    },
    moreRecords: {
      moreRecordsMessageTitle: msg(
        'pam.landingPage.moreRecords.title',
        'Too many assets to show.'
      ),
      moreRecordsMessageDescription: msg(
        'pam.landingPage.moreRecords.description',
        'To find the available assets you need, type in the search bar and use filters.'
      ),
      moreRecordsMessageTitleJfa: msg(
        'pam.landingPage.moreRecords.titleJfa',
        'Too many roles to show.'
      ),
      moreRecordsMessageDescriptionJfa: msg(
        'pam.landingPage.moreRecords.descriptionJfa',
        'To find the available roles you need, type in the search bar and use filters.'
      ),
    },
    scheduler: {
      today: msg('pam.scheduler.today', 'Today'),
      sunday: msg('pam.scheduler.sunday', 'Sunday'),
      monday: msg('pam.scheduler.monday', 'Monday'),
      tuesday: msg('pam.scheduler.tuesday', 'Tuesday'),
      wednesday: msg('pam.scheduler.wednesday', 'Wednesday'),
      thursday: msg('pam.scheduler.thursday', 'Thursday'),
      friday: msg('pam.scheduler.friday', 'Friday'),
      saturday: msg('pam.scheduler.saturday', 'Saturday'),
      availableForRequest: msg(
        'pam.scheduler.availableForRequest',
        'Available for request'
      ),
      booked: msg('pam.scheduler.booked', 'Booked'),
      requested: msg('pam.scheduler.requested', 'Requested'),
      complete: msg('pam.scheduler.complete', 'Complete'),
    },
    sessionLauncher: {
      label: {
        serverType: msg(
          'pam.sessionLauncher.label.ipInputServerType',
          SESSION_DETAILS_MODAL_ISLAND.SERVER_TYPE
        ),
        ipInput: msg(
          'pam.sessionLauncher.label.ipInputServer',
          SESSION_DETAILS_MODAL_ISLAND.SERVER
        ),
        portInput: msg(
          'pam.sessionLauncher.label.portInput',
          SESSION_DETAILS_MODAL_ISLAND.PORT_NUMBER
        ),
      },
      placeholder: {
        serverType: msg(
          'pam.sessionLauncher.placeholder.serverType',
          SESSION_DETAILS_MODAL_ISLAND.SERVER_TYPE_PLACEHOLDER
        ),
        ipInput: msg(
          'pam.sessionLauncher.placeholder.ipInput',
          SESSION_DETAILS_MODAL_ISLAND.IP_PLACEHOLDER
        ),
        portInput: msg(
          'pam.sessionLauncher.placeholder.portInput',
          SESSION_DETAILS_MODAL_ISLAND.PORT_INPUT_PLACEHOLDER
        ),
      },
      buttons: {
        cancel: msg(
          'pam.sessionLauncher.buttons.cancel',
          SESSION_DETAILS_MODAL_ISLAND.CANCEL
        ),
        launch: msg(
          'pam.sessionLauncher.buttons.launch',
          SESSION_DETAILS_MODAL_ISLAND.LAUNCH
        ),
      },
      heading: {
        detailsHeading: msg(
          'pam.sessionLauncher.heading.detailsHeading',
          SESSION_DETAILS_MODAL_ISLAND.LAUNCH_SESSION
        ),
        detailsSubheading: msg(
          'pam.sessionLauncher.heading.detailsSubheading',
          SESSION_DETAILS_MODAL_ISLAND.MODAL_ISLAND_SUBHEADING
        ),
      },
      critical: {
        ipHelperText: msg(
          'pam.sessionLauncher.critical.ipHelperText',
          SESSION_DETAILS_MODAL_ISLAND.SECONDARY_IP_CRIT_MESSAGE
        ),
        portHelperText: msg(
          'pam.sessionLauncher.critical.portHelperText',
          SESSION_DETAILS_MODAL_ISLAND.SECONDARY_PORT_CRIT_MESSAGE
        ),
      },
    },
    pamCheckInModal: {
      extendLabel: msg('pam.sidePanel.extend', 'Extend'),
      connectButtonTooltip: msg('Pam.connect.tooltip', 'Launch Session'),
      hasCredentialsTooltip: msg(
        'pam.hasCredentialsTooltip.tooltip',
        'Has Credentials'
      ),
      endButtonCredentiallessTooltip: msg('Pam.end.tooltip', 'End Session'),
      endButtonCredentialedTooltip: msg(
        'Pam.checkIn.tooltip',
        'Check In Credential'
      ),
      checkInRoleTooltip: msg('pam.checkIn.tooltipRole', 'Check In Role'),
      checkOutRoleTooltip: msg('pam.checkOut.tooltipRole', 'Check Out Role'),
      checkOutAssetTooltip: msg(
        'pam.checkOut.tooltipCredential',
        'Check Out Credential'
      ),
      cancelRequestLabel: msg('pam.cancelRequest.title', 'Cancel Request'),
      cancelSessionLabel: msg('pam.cancelSession.title', 'Cancel Session'),
      pendingApproval: msg('pam.pendingApproval.title', 'Pending Approval'),
    },
    apiKeys: {
      sectionTitle: msg('pam.accessKeys.sectionTitle', 'Access Keys'),
      headerTitle: msg(
        'pam.accessKeys.headerTitle',
        'Using a native SSH app or CLI tool?'
      ),
      headerDescription: msg(
        'pam.accessKeys.headerDescription',
        'Download an Access key to authenticate directly from your desktop application or command-line tool — no need to launch sessions from this page.'
      ),
      downloadNewKey: msg('pam.accessKeys.downloadNewKey', 'Download new key'),
      deleteKeyLimitNote: msg(
        'pam.accessKeys.deleteKeyLimitNote',
        'Delete a key to create a new one'
      ),
      emptyState: msg(
        'pam.accessKeys.emptyState',
        'No active keys. Download a key to use with your native SSH app or CLI.'
      ),
      keysUsed: msg('pam.accessKeys.keysUsed', '{count} of {max} keys used'),
      blueKey: msg('pam.accessKeys.blueKey', 'Blue Key'),
      greenKey: msg('pam.accessKeys.greenKey', 'Green Key'),
      active: msg('pam.accessKeys.active', 'Active'),
      scheduled: msg('pam.accessKeys.scheduled', 'Scheduled'),
      starts: msg('pam.accessKeys.starts', 'Starts'),
      expires: msg('pam.accessKeys.expires', 'Expires'),
      deleteKey: msg('pam.accessKeys.deleteKey', 'Delete key'),
      deleteKeySlot: msg('pam.accessKeys.deleteKeySlot', 'Delete key {slot}'),
      deleteKeyConfirm: msg(
        'pam.accessKeys.deleteKeyConfirm',
        'Are you sure you want to delete this key?'
      ),
      deleteKeyButton: msg('pam.accessKeys.deleteKeyButton', 'Delete Key'),
      attemptingDelete: msg(
        'pam.accessKeys.attemptingDelete',
        'Attempting to Delete Key'
      ),
      deleteSuccessDescription: msg(
        'pam.accessKeys.deleteSuccessDescription',
        'The Access Key has been successfully deleted.'
      ),
      deleteFailureDescription: msg(
        'pam.accessKeys.deleteFailureDescription',
        'Unable to delete the Access Key. Please try again.'
      ),
      generateSuccessDescription: msg(
        'pam.accessKeys.generateSuccessDescription',
        'The Access key has been successfully generated and downloaded.'
      ),
      generateFailureDescription: msg(
        'pam.accessKeys.generateFailureDescription',
        'Unable to generate the Access key. Please try again.'
      ),
      download: {
        title: msg('pam.accessKeys.download.title', 'Download Access Keys'),
        subtitle: msg(
          'pam.accessKeys.download.subtitle',
          'Choose when the key becomes active. Expiry is calculated from the start time.'
        ),
        startTime: msg('pam.accessKeys.download.startTime', 'Start time'),
        startNow: msg('pam.accessKeys.download.startNow', 'Start now'),
        schedule: msg('pam.accessKeys.download.schedule', 'Schedule'),
        scheduleInfo: msg(
          'pam.accessKeys.download.scheduleInfo',
          'Future start must be within the next 24 hours.'
        ),
        startDateRequired: msg(
          'pam.accessKeys.download.startDateRequired',
          'Start date is required.'
        ),
        startTimeRequired: msg(
          'pam.accessKeys.download.startTimeRequired',
          'Start time is required.'
        ),
        activeFrom: msg('pam.accessKeys.download.activeFrom', 'Active from'),
        expiresLabel: msg('pam.accessKeys.download.expiresLabel', 'Expires'),
        validFor: msg(
          'pam.accessKeys.download.validFor',
          'Valid for {hours} hours.'
        ),
        passphrase: msg('pam.accessKeys.download.passphrase', 'Passphrase'),
        passphraseHint: msg(
          'pam.accessKeys.download.passphraseHint',
          'Encrypts the key file. If set, you will need it every time you use the key.'
        ),
        passphrasePlaceholder: msg(
          'pam.accessKeys.download.passphrasePlaceholder',
          'Enter passphrase'
        ),
        confirmPassphrase: msg(
          'pam.accessKeys.download.confirmPassphrase',
          'Confirm passphrase'
        ),
        confirmPlaceholder: msg(
          'pam.accessKeys.download.confirmPlaceholder',
          'Re-enter passphrase'
        ),
        passphraseMismatch: msg(
          'pam.accessKeys.download.passphraseMismatch',
          'Passphrases do not match.'
        ),
        passphraseLengthError: msg(
          'pam.accessKeys.download.passphraseLengthError',
          'Passphrase must be between {min} and {max} characters.'
        ),
        passphraseWarning: msg(
          'pam.accessKeys.download.passphraseWarning',
          'The passphrase you set here cannot be retrieved later. If you forget it, you will need to download a new set of keys.'
        ),
      },
    },
    mfa: {
      title: msg('pam.mfa.title', 'Verify Your Identity'),
      subtitle: msg(
        'pam.mfa.subtitle',
        'Open your authenticator and enter the passcode to verify your identity.'
      ),
      codeLabel: msg('pam.mfa.codeLabel', '6-Digit Code'),
      codePlaceholder: msg('pam.mfa.codePlaceholder', 'Enter the 6-digit code'),
      verify: msg('pam.mfa.verify', 'Verify'),
      verifying: msg('pam.mfa.verifying', 'Verifying'),
      invalidCode: msg(
        'pam.mfa.invalidCode',
        'Invalid code. Please try again.'
      ),
      accountLocked: msg(
        'pam.mfa.accountLocked',
        'Your account is locked. Contact your administrator.'
      ),
      notRegistered: msg(
        'pam.mfa.notRegistered',
        'MFA is not set up for your account. Contact your administrator.'
      ),
      userNotFound: msg(
        'pam.mfa.userNotFound',
        'We could not verify your account. Contact your administrator.'
      ),
      serviceUnavailable: msg(
        'pam.mfa.serviceUnavailable',
        'The verification service is unavailable. Please try again later.'
      ),
      genericError: msg(
        'pam.mfa.genericError',
        'Something went wrong during verification. Please try again.'
      ),
    },
  },
};
